import { FlexRow } from '@/components/common/Flex';
import { FlexProps, Grid, GridProps, Square } from '@chakra-ui/react';
import { getSectorProps } from '@common/react/goals';
import { GoalAccountInvestmentType } from '@common/types';
import PieChart, { PieChartProps } from '../common/charts/PieChart';
import { Text } from '../common/Typography';

interface GoalSectorsPieChartProps extends Omit<PieChartProps, 'data'> {
    investmentType: GoalAccountInvestmentType;
    riskScore: number;
    size?: FlexProps['h'];
}

export function GoalSectorsPieChart({
    investmentType,
    riskScore,
    size = 32,
    ...props
}: GoalSectorsPieChartProps) {
    const sectors = getSectorProps({ investmentType, riskScore });

    return <PieChart {...props} h={size} w={size} data={sectors} />;
}

interface GoalSectorsPieChartLegendProps extends GridProps {
    investmentType: GoalAccountInvestmentType;
    riskScore: number;
    layoutDirection: 'vertical' | 'horizontal';
}

export function GoalSectorsPieChartLegend({
    investmentType,
    riskScore,
    layoutDirection,
    ...props
}: GoalSectorsPieChartLegendProps) {
    const sectors = getSectorProps({ investmentType, riskScore });

    const isOneSector = sectors.length === 1;
    const numCols = 1;

    return (
        <Grid
            templateColumns={`repeat(${numCols}, 1fr)`}
            gap={4}
            justifyContent="center"
            {...props}
        >
            {sectors.map(({ key, value, color, label }) => (
                <FlexRow
                    key={key}
                    w="full"
                    h={2.5}
                    align="center"
                    justify={
                        layoutDirection === 'horizontal' && isOneSector
                            ? 'center'
                            : 'flex-start'
                    }
                >
                    <Square rounded={2} size={3.5} bg={color} mr={4} />
                    <Text fontSize="sm" color="gray">
                        {value + '% ' + label}
                    </Text>
                </FlexRow>
            ))}
        </Grid>
    );
}
